import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { FormRevisionDTO, NewFormRevisionRequest, UpdateFormRevisionRequest } from "../dto/form-revision";
import { IQueryCommand, NumberFilter } from "@features/filter";
import { PagedCrudService } from "@features/grid";
import { NumberArrayFilter } from "@features/filter/classes/number-array-filter";
import { firstValueFrom } from "rxjs";
import { S3Service } from "@features/bb-formio/Providers/s3";
import { Key } from "protractor";

@Injectable()
export class FormIORevisionService extends PagedCrudService<FormRevisionDTO> {
    public readonly url = "api/formio-revision";
    public readonly entityTitle = "Form Revision";
    public formDefinitionId = -1;

    public extendQueryCommand(queryCommand: IQueryCommand) {
        queryCommand.filters = queryCommand.filters || [];
        queryCommand.filters.push(new NumberFilter("formDefinitionId", this.formDefinitionId));
    }

    constructor(http: HttpClient,
                public formIOFileUploaderService: S3Service,
                handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async updateFormRevision(formRevisionId: string, requestData: UpdateFormRevisionRequest): Promise<boolean> {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/${formRevisionId}`, requestData),
            this.handlersFactory.getForUpdate(this.entityTitle));
    }

    public async createFormRevision(requestData: NewFormRevisionRequest): Promise<boolean> {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/new`, requestData),
            this.handlersFactory.getForCreate(this.entityTitle));
    }

    public async setActiveStatus(formId: string, revisionId: string) {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/active/${formId}/${revisionId}`, {}),
            this.handlersFactory.getForUpdate(this.entityTitle));
    }

    public downloadContentFromStorage = async (json: string): Promise<string> => {
        const fileStorageTag = "#fileStorageKey:";
        let keysToLoad: string[] = [];

        const matches = [...json.matchAll(new RegExp("\"" + fileStorageTag + "(.*)" + "\",", "g"))];
        keysToLoad = matches.map(match => match[1]);

        if (keysToLoad) {
            const results = await this.formIOFileUploaderService.downloadContentStrings(keysToLoad);
            keysToLoad.forEach((key, keyIndex) => {
                json = json.replace(`${fileStorageTag}${key}`, JSON.stringify(results[keyIndex]).slice(1, -1));
            })
        }
        return json;
    };
}